// removed by extract-text-webpack-plugin
module.exports = {"story-container":"src-components-News-singleStory-___singleStory__story-container___10-6i","image-container":"src-components-News-singleStory-___singleStory__image-container___YQiJp","content-list":"src-components-News-singleStory-___singleStory__content-list___3Aq1m","title":"src-components-News-singleStory-___singleStory__title___1NXbW","date":"src-components-News-singleStory-___singleStory__date___1CPk7","dek":"src-components-News-singleStory-___singleStory__dek___2-wpm"};


//////////////////
// WEBPACK FOOTER
// ./src/components/News/singleStory/singleStory.css
// module id = 797
// module chunks = 0